/**
 * Viewport breakpoints for web surfaces.
 *
 * A breakpoint is the viewport width at which a web page changes layout. The
 * design system is width-agnostic everywhere else — a phone is always a
 * single column — so this element exists only for web hosts whose chrome
 * changes shape on wider viewports.
 *
 * Source of truth: Pangea Galapagos UI Design System — Beta
 * https://www.figma.com/design/Orc6uUodQaoXep59CGaUNw
 *
 * `column` has no Figma name yet: it is the width at which `apps/web` already
 * switches its site header from the compact to the desktop layout. The page
 * column itself is capped at `sizing.column.max` at every width; this value
 * is kept beside it so a later decision to let the column go full-bleed on
 * narrow viewports can switch at the same pixel as the chrome. It stays
 * flagged in the web-registration legacy-value inventory until design names it.
 */

export const breakpointKeys = ['column'] as const;
export type BreakpointToken = (typeof breakpointKeys)[number];

export const breakpoints = {
  /** Viewport width (px) at and above which the web site chrome uses its desktop layout. */
  column: 640,
} as const satisfies Record<BreakpointToken, number>;

export type Breakpoints = typeof breakpoints;
